import styled from 'styled-components';
import newBrandDesignVars from './overwrite-vars.scss';

const NewCreditText = styled.span`
  font-size: 1rem;
  color: ${newBrandDesignVars.grey1};
`;

export default NewCreditText;
